var React = require('react');

function ID (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M43.68 41.52l-2.080-2.32-0.8 1.040 0.32 0.88-5.12-0.16-0.88 0.96-2.24-0.32-0.72 1.12-0.88-0.88-0.96-2.88-1.2-0.080-0.72-0.72v-1.36l-1.68-2.64-0.56-2.64-0.96-0.88-2.080 1.92-1.6-0.88 0.4-1.2-0.4-0.64 1.040-0.88-0.64-2.56 0.4-0.24 0.88-4.4-1.6 0.16-0.56-0.88-0.72 0.32-3.12-5.12-2.4-1.68 0.4-0.4-0.4-0.64 0.16-1.36-2-2.88 0.48-8.8-5.92-0.4-1.44 23.52 1.2 4.32 1.52 1.52 0.72 1.44-2.88 5.12-0.16 1.28-2.48 3.44v1.68l1.36 0.4 0.64 0.8-1.2 3.040-0.8 16.56 20 0.8 20.080 0.080z"}));
}

ID.defaultProps = {"version":"1.1","width":"48","height":"80","viewBox":"0 0 48 80"};

module.exports = ID;

ID.default = ID;
